import get from 'lodash/get';
import { buildSeenReleases } from './helpers';

export const selectWhatsNewSeenReleases = (state) => get(state, 'preferences.whats_new.seen_releases', []);

export const selectHasUnseenWhatsNew = (versionIds) => (state) => {
  const storedSeenReleases = selectWhatsNewSeenReleases(state);
  return buildSeenReleases(versionIds, storedSeenReleases).some((release) => !release.seen);
};
